export class DirectiveHelpers {
    public static create = (directiveConstructor: Function) => {

        var directiveFactory: ng.IDirectiveFactory = (...args: any[]) => {
            args.unshift(null);
            var ctor = directiveConstructor.bind.apply(directiveConstructor, args);
            return new ctor();
        }

        directiveFactory.$inject = directiveConstructor.$inject;

        return directiveFactory;
    }
}

export class ServiceHelpers {
    public static create = (serviceConstructor: Function) => {
        var directiveFactory: ng.IServiceProviderFactory = (...args: any[]) => {
            args.unshift(null);
            var ctor = serviceConstructor.bind.apply(serviceConstructor, args);
            return new ctor();
        }
        directiveFactory.$inject = serviceConstructor.$inject;
        return directiveFactory;
    }
}

export class ControllerHelpers {
    public static create = (controllerConstructor: Function) => {
        var directiveFactory: any = (...args: any[]) => {
            args.unshift(null);
            var ctor = controllerConstructor.bind.apply(controllerConstructor, args);
            return new ctor();
        }
        directiveFactory.$inject = controllerConstructor.$inject;
        return directiveFactory;
    }
}

export class FilterHelpers {
    public static create = (filterFunction: Function) => {
        return () => filterFunction;
    }
}

export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}
